module.exports = __webpack_public_path__ + "img/taili3.3760db9e.jpg";